import * as React from 'react';
import {Box, Divider, Grid, Typography} from "@mui/material";
import {SrsStages} from "../types/stats";
import DashboardPanel from "./DashboardPanel";

export interface StageDistributionProps {
    stages: SrsStages
    ready: boolean
}

export default function StageDistributionGridView({stages, ready} : StageDistributionProps) {

    function ovalView(title : string, value : number) {
        return (
            <Box bgcolor="primary.main"
                 sx={{borderRadius: 2, border: '1px gray solid', pb: 0, mb: 0, mt: 0}}
                 px={{xs: 1, sm: 1}}
            >
                <Typography variant="body2">{title}</Typography>
                <Divider sx={{border: 1, backgroundColor: 'black'}}/>
                <Typography variant="h6" align="right">{value}</Typography>
            </Box>
        )
    }

    return (
        <DashboardPanel title="Stages" ready={ready} skeletonHeight={250} height={250}>
            <Box sx={{px: 2}}>
                <Grid container spacing={1} sx={{mt: 0.05}}>
                    {Array.from(stages.entries()).map(([key, value]) => (
                        <Grid key={key} item xs={4}>
                            {ovalView(`Stage ${key}`, value)}
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </DashboardPanel>
    );
}
